@if (config) {
  <app-header />

  <main id="main">
    <router-outlet />
  </main>

  <app-footer />

  @if (overlayService.state() !== OverlayState.None) {
    <app-overlay [message]="overlayMessage()" />
  }
}
